import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useSnackbar } from 'notistack'

import { ROUTES, STORAGE_KEYS } from 'src/constants'
import { joinAbsRoute } from 'src/common/utils'

const useAuthenticatedRedirect = () => {
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    const accessToken = searchParams.get('accessToken')
    const refreshToken = searchParams.get('refreshToken')
    const redirectToken = searchParams.get('redirectToken')
    const accountId = searchParams.get('accountId')
    const isCustomer = searchParams.get('customer')?.trim() === 'true'

    const scannerAccountId = searchParams.get('scannerAccountId')
    const message = searchParams.get('message')
    if (message) {
      enqueueSnackbar(message, {
        variant: 'error',
      })
      setSearchParams((prev) => {
        prev.delete('message')
        return prev
      })
    }

    if (accessToken && refreshToken) {
      localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken)
      localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken)
      enqueueSnackbar('You have successfully authenticated', { variant: 'success' })

      if (redirectToken) {
        const decode = atob(redirectToken.split('.')[1])
        const data = JSON.parse(decode)

        if ('journeyRedirect' in data) {
          window.location.replace(
            data.journeyRedirect + `?accessToken=${accessToken}&refreshToken=${refreshToken}`,
          )
          return
        }
      }

      navigate(
        isCustomer
          ? joinAbsRoute(ROUTES.USER, ROUTES.USER_DASHBOARD)
          : accountId
            ? joinAbsRoute(ROUTES.ACCOUNTS, accountId.trim(), ROUTES.DASHBOARD)
            : scannerAccountId
              ? joinAbsRoute(ROUTES.ACCOUNTS, scannerAccountId.trim(), ROUTES.SCAN_HISTORY)
              : joinAbsRoute(ROUTES.ACCOUNTS),
        { replace: true },
      )
    }
  }, [navigate, searchParams, enqueueSnackbar, setSearchParams])
}

export { useAuthenticatedRedirect }
